import React from 'react';
import {LoginCallback, SecureRoute, Security} from '@okta/okta-react';
import {OktaAuth, toRelativeUrl} from '@okta/okta-auth-js';
import {BrowserRouter as Router, Route, Switch, useHistory, withRouter} from "react-router-dom";
import Datadog from './config/datadog'
import WtyReportHome from "./features/common/WtyReportHome";
import SignOut from "./app/SignOut";
import './App.css';
import '@deere/ux.uxframe-core/dist/css/uxframe.min.css';
import {TranslationProvider} from "./features/Translation/TranslationContext";

const oktaAuth = new OktaAuth({
    issuer: process.env.REACT_APP_ISSUER_URL,
    clientId: process.env.REACT_APP_CLIENT_ID,
    scope: ['openid, profile'],
    redirectUri: window.location.origin + '/login/callback',
    logoutUrl: window.location.origin + '/logout',
    postLogoutRedirectUri: window.location.origin + '/signOut',
    tokenManager: {
        storage: 'sessionStorage', autoRenew: true,
    },
    pkce: true
});


function App() {

    const history = useHistory();
    const restoreOriginalUri = async (_oktaAuth, originalUri) => {
        history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
    };

    const nodeEnv = process.env.NODE_ENV || 'local'

    return (<div className="root-container">
        {nodeEnv !== 'local' && <Datadog />}
        <Security
            oktaAuth={oktaAuth}
            restoreOriginalUri={restoreOriginalUri}
        >
            <Switch>
                <Route path='/login/callback' component={LoginCallback}/>
                <Route path="/signOut" component={SignOut}/>
                <SecureRoute path='/' component={WtyReportHome}/>
            </Switch>
        </Security>
    </div>);
}

const AppWithRouterAccess = withRouter(App);

const RouterApp = () => {
    return (<Router>
        <TranslationProvider>
            <AppWithRouterAccess/>
        </TranslationProvider>
         </Router>)
}
export default RouterApp;
